import { gql } from "@apollo/client";
import PositionFields from "../fragments/position-fragment";
import PositionWorkerFields from "../fragments/position-worker-fragment";

export default gql`
  mutation editPositionRates($employerId: String!, $data: PositionRatesInput!) {
    editPositionRates(data: $data) {
      ...PositionFields
      worker {
        ...PositionWorkerFields
        positionCountByEmployer(employerId: $employerId)
      }
    }
  }
  ${PositionFields}
  ${PositionWorkerFields}
`;

export const EditPositionRatesFromDialog = gql`
  mutation editPositionRates($data: PositionRatesInput!) {
    editPositionRates(data: $data) {
      id
    }
  }
`;
